import React from 'react';
import { fmtNum } from './format';

// DESIGN V2 — the toolbar above an entity page's full-width list: a segment
// switch on the left (e.g. "They played · 797 | Their tracks played by
// others · 110"), tools (filter, Play all, dev toggles) on the right.
// segments: [{ key, label, count? }]
export default function ListToolbar({ segments, value, onChange, children }) {
    return (
        <div className="v2-list-toolbar">
            <div className="v2-segments" role="tablist">
                {segments.map((s) => (
                    <button key={s.key} type="button" role="tab" aria-selected={value === s.key} className={value === s.key ? 'on' : ''} onClick={() => onChange(s.key)}>
                        {s.label}{s.count != null && s.count > 0 && <span className="v2-num">{fmtNum(s.count)}</span>}
                    </button>
                ))}
            </div>
            {children && <div className="v2-list-tools">{children}</div>}
        </div>
    );
}
